import React, { useMemo, useState, useContext, createContext } from 'react';
import pt from 'prop-types';

export const InlineEditableContext = createContext({
  editing: false,
  /** @type {React.Dispatch<React.SetStateAction<boolean>>} */
  setEditing: () => {},
});

function InlineEditableProviderComponent({ theme, children }) {
  const [editing, setEditing] = useState(false);

  const { locale, defaultLocale } = useMemo(() => {
    const defaultLocale = theme.swell.storefront.settings.getStoreLocale();
    const { locale } = theme.swell.getStorefrontLocalization();

    return { locale, defaultLocale };
  }, [theme]);

  const value = useMemo(() => {
    return { locale, defaultLocale, editing, setEditing };
  }, [editing, locale, defaultLocale]);

  return (
    <InlineEditableContext.Provider value={value}>
      {children}
    </InlineEditableContext.Provider>
  );
}

InlineEditableProviderComponent.propTypes = {
  theme: pt.object,
  children: pt.oneOfType([pt.element, pt.array]),
};

export const InlineEditableProvider = React.memo(
  InlineEditableProviderComponent,
);

export const useInlineEditable = () => {
  const context = useContext(InlineEditableContext);

  if (!context) {
    throw new Error(
      'useInlineEditable must be used within an InlineEditableProvider',
    );
  }

  return context;
};
